type PageHeaderProps = {
  title: string;
  eyebrow?: string;
  titleClassName?: string;
  description?: string;
};

export function PageHeader({ title, eyebrow, titleClassName, description }: PageHeaderProps) {
  return (
    <div className="page-header" aria-label={title}>
      {eyebrow ? <div className="page-header-eyebrow eyebrow">{eyebrow}</div> : null}
      <div className="page-header-main">
        <h1 className={`page-header-title${titleClassName ? ` ${titleClassName}` : ''}`}>{title}</h1>
        <span className="page-header-rule" aria-hidden="true" />
      </div>
      {description ? <p className="page-header-description">{description}</p> : null}
    </div>
  );
}
